import { render, staticRenderFns } from "./QuestionPlanForm.vue?vue&type=template&id=05282bd7&scoped=true&"
import script from "./QuestionPlanForm.vue?vue&type=script&lang=js&"
export * from "./QuestionPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05282bd7",
  null
  
)

export default component.exports